import { Empty, Form, Modal, Select } from '@maxtropy/components';
import {
  apiV2MicrogridOverviewGetBsaStrategyListPost,
  apiV2MicrogridOverviewUpsertBsaStrategyConfigPost,
  V2MicrogridOverviewGetBsaStrategyListPostResponse,
} from '@maxtropy/intelligent-dispath-apis-v2';
import { isNil } from 'lodash-es';
import { useEffect, useState } from 'react';

interface AddUnitModalProps {
  microgridId?: number;
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

export type BsaItem = Exclude<V2MicrogridOverviewGetBsaStrategyListPostResponse['list'], undefined>[number];

const ConfigModal: React.FC<AddUnitModalProps> = ({ microgridId, visible, setVisible }) => {
  const [form] = Form.useForm();
  const [bsaList, setBsaList] = useState<BsaItem[]>([]);

  useEffect(() => {
    if (isNil(microgridId)) return;
    apiV2MicrogridOverviewGetBsaStrategyListPost({ id: microgridId }).then(res => {
      setBsaList(res.list ?? []);

      const list = (res.list ?? []).reduce((acc: Record<string, number>, cur) => {
        acc[String(cur.bsaId)] = cur.strategyId!;
        return acc;
      }, {});

      form.setFieldsValue({ ...list });
    });
  }, []);

  const onFinish = (v: any) => {
    const list = Object.keys(v).map(key => {
      return {
        bsaId: Number(key),
        strategyId: v[key],
      };
    });
    apiV2MicrogridOverviewUpsertBsaStrategyConfigPost({ configId: microgridId, bsaStrategyIdList: list }).then(res => {
      setVisible(false);
    });
  };

  return (
    <Modal
      open={visible}
      title="未执行策略配置"
      contentClassName="modal-form-content"
      onOk={() => {
        form.submit();
      }}
      onCancel={() => {
        setVisible(false);
      }}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        {bsaList.length === 0 ? (
          <Empty description="暂无储能站" />
        ) : (
          bsaList.map((bsa, index) => {
            return (
              <Form.Item label={`${bsa.bsaName}储能站策略模板`} name={`${bsa.bsaId}`} required key={index}>
                <Select
                  placeholder="请选择"
                  options={(bsa?.strategyList ?? []).map(m => ({ label: m.name, value: m.id }))}
                />
              </Form.Item>
            );
          })
        )}
      </Form>
    </Modal>
  );
};

export default ConfigModal;
